"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _AaStepper = _interopRequireDefault(require("../airasia-stepper-component/AaStepper.component"));

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var _AaPassengerRoomSelection = require("./AaPassengerRoomSelection.model");

var _uiUtils = require("@airasia/ui-utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var AaPassengerSelectionStepper = function AaPassengerSelectionStepper(props) {
  var _useState = (0, _react.useState)(props),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      selectionStepperProps = _useState2[0],
      setSelectionStepperProps = _useState2[1];

  (0, _react.useEffect)(function () {
    setSelectionStepperProps(props);
  }, [props]);

  var onIncrementPax = function onIncrementPax() {
    props.controls.stepperClicked(selectionStepperProps.controls.type, 'inc');
  };

  var onDecrementPax = function onDecrementPax() {
    props.controls.stepperClicked(selectionStepperProps.controls.type, 'dec');
  };

  var stepperControls = {
    onIncrement: onIncrementPax,
    onDecrement: onDecrementPax,
    showNumber: true,
    min: selectionStepperProps.controls.min
  };

  var combinedStepperControls = _objectSpread({}, stepperControls);

  var propsAccessibility = {
    addAccessibilityProps: null,
    removeAccessibilityProps: null
  };

  if (selectionStepperProps.controls.accessibilityProps) {
    if (selectionStepperProps.controls.accessibilityProps.addButtonProps) {
      propsAccessibility.addAccessibilityProps = selectionStepperProps.controls.accessibilityProps.addButtonProps;
    }

    if (selectionStepperProps.controls.accessibilityProps.removeButtonProps) {
      propsAccessibility.removeAccessibilityProps = selectionStepperProps.controls.accessibilityProps.removeButtonProps;
    }

    combinedStepperControls = _objectSpread(_objectSpread({}, stepperControls), {}, {
      accessibilityProps: propsAccessibility
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.container
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, null, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: styles.label
  }, selectionStepperProps.controls.description[selectionStepperProps.controls.type].label), selectionStepperProps.controls.description[selectionStepperProps.controls.type].sublabel ? /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: styles.subLabel
  }, selectionStepperProps.controls.description[selectionStepperProps.controls.type].sublabel) : null), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, null, /*#__PURE__*/_react["default"].createElement(_AaStepper["default"], {
    controls: _objectSpread(_objectSpread({}, combinedStepperControls), {}, {
      max: selectionStepperProps.controls.max
    }),
    data: selectionStepperProps.data
  })));
};

var styles = _StyleSheet["default"].create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 15
  },
  label: {
    fontSize: 16,
    color: "#212124",
    fontFamily: _uiUtils.DefaultTokens.FONT_MEDIUM,
    web: {
      fontWeight: '500',
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB
    }
  },
  subLabel: {
    fontSize: 12,
    color: "#75767a",
    fontFamily: _uiUtils.DefaultTokens.FONT_REGULAR,
    web: {
      fontWeight: '400',
      fontFamily: _uiUtils.DefaultTokens.FONT_WEB
    }
  }
});

var _default = AaPassengerSelectionStepper;
exports["default"] = _default;